import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import { PackageData, PackageFilter } from '../../models/package.model'
import { PackageService } from '../../services/package.service'

@Component({
  selector: 'app-packages-list',
  templateUrl: './packages-list.component.html',
  styleUrls: ['./packages-list.component.scss'],
})
export class PackagesListComponent implements OnInit {
  packages: PackageData[] = []
  packageFilter: PackageFilter = {
    paging: { pageNumber: 1, pageSize: 10 },
    branchId: 0,
    searchText: '',
  }
  totalCount = 0
  subscription = new Subscription()
  queryParams: any = {}
  constructor(
    private router: Router,
    public ActivatedRoute: ActivatedRoute,
    private SharedService: SharedService,
    private packageServ: PackageService
  ) {
    this.SharedService.headerTitle.next(
      localStorage.getItem('activeOrganization') || ''
    )
  }

  ngOnInit(): void {
    this.subscription.add(
      this.ActivatedRoute.queryParams.subscribe((res) => {
        this.queryParams = { ...res }
        this.packageFilter.paging.pageNumber = res['page'] || 1
        this.packageFilter.paging.pageSize = res['count'] || 10
        this.packageFilter.branchId = res['branchId']
        this.SharedService.handleBreadCrumb('packages', false, {
          name: '',
          id: null,
          url: this.router.url.split('?')[0],
          queryParams: { ...res },
        })
        this.getPackages()
      })
    )
  }

  getPackages() {
    this.subscription.add(
      this.packageServ
        .getPackagesList(this.packageFilter)
        .subscribe((res: any) => {
          this.packages = res?.result?.items
          this.totalCount = res?.result?.totalCount
        })
    )
  }

  pageChanged(pageNumber: number, pageCount: number) {
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: {
        ...this.queryParams,
        page: pageNumber,
        count: pageCount,
      },
    })
  }

  addPackage() {
    this.router.navigateByUrl(
      this.router.createUrlTree(
        ['layout/service-providers/organization-profile/packages/add-package'],
        {
          queryParams: {
            branchId: this.packageFilter.branchId,
          },
        }
      )
    )
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
